
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

import BbsDialog from '@/components/BbsDialog/index.vue';
import EditDialogHandUp from '@/components/EditDialog/index.vue';

import {
  getAllOrderDetail,
  getOrderDetail,
} from '@/api/order';

import OrderInfo from '@/components/OrderInfo/OrderInfo.vue'
import OrderServiceInfo from '@/components/OrderInfo/OrderServiceInfo.vue'
import { getOrderCheckDetail } from '@/api/orderCheck';
import OrderTopTitle from '@/components/OrderInfo/OrderTopTitle.vue'

@Component({
  name: 'orderDetail',
  components: {
    EditDialogHandUp,
    BbsDialog,
    OrderTopTitle,
    OrderInfo,
    OrderServiceInfo
  },
  filters: {

  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
    required: true
  })
  DetailsDataQuery!: any;

  private orderId = '';
  private orderServiceId = '';
  private orderDetail: any = {
    order: {},
    order_service: {}
  };
  private isDetail=true;
  private all=false;

  private topButtonList:any=[]
  private showBJD:boolean=false;
  private showComplaintBtn:boolean=false;
  private tabName:any='';
  private isCheckOrder:any=false;

  created() {
    if (this.DetailsDataQuery && this.DetailsDataQuery.order_service_id) {
      this.orderServiceId = this.DetailsDataQuery.order_service_id as any;
      this.orderId = this.DetailsDataQuery.orderId as any;
      this.all = parseInt(this.DetailsDataQuery.all as string) === 1;
      this.showBJD = parseInt(this.DetailsDataQuery.showBJD as string) === 1;
      this.showComplaintBtn = parseInt(this.DetailsDataQuery.showComplaintBtn as string) === 1;
      this.isCheckOrder = parseInt(this.DetailsDataQuery.isCheckOrder as string) === 1;
      this.tabName = this.DetailsDataQuery.tabName;
    } else {
      this.orderServiceId = this.$route.query.order_service_id as any;
      this.orderId = this.$route.query.orderId as any;
      this.all = parseInt(this.$route.query.all as string) === 1;
      this.showBJD = parseInt(this.$route.query.showBJD as string) === 1;
      this.showComplaintBtn = parseInt(this.$route.query.showComplaintBtn as string) === 1;
      this.isCheckOrder = parseInt(this.$route.query.isCheckOrder as string) === 1;
      this.tabName = this.$route.query.tabName;
    }
    this.getOrderDetaila();
  }
  private back() {
    this.$router.back();
  }
  private getTagsHtml(r: any) {
    let kind = "";
    let kindType = "";
    let abnormal = "";
    let plain = "plain";
    if (parseInt(r.order.order_type) === 1) {
      kind = "其他";
      kindType = "warning";
    } else if (parseInt(r.order.order_type) === 2) {
      kind = "维保";
      kindType = "success";
    } else if (parseInt(r.order.order_type) === 3) {
      kind = "安装";
      kindType = "danger";
    } else if (parseInt(r.order.order_type) === 4) {
      kind = "巡检";
      kindType = "";
      if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
        abnormal = "巡异";
      }
    } else {
      kind = "维保";
      kindType = "success";
    }

    let source = "";
    if (r.order.customer_company_id === r.order_service.servicer_company_id) {
      source = "内部";
    } else {
      source = "外部";
    }
    if (parseInt(r.order_service.transfer_in) === 1) {
      source = "转入";
    }
    if (parseInt(r.order_service.transfer_out) === 1) {
      source = "转出";
    }

    let charge = "";
    let darkplain = "dark";
    if (parseInt(r.order_service.charge) === 1) {
      charge = "收费";
    }

    let expedited = "";
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = "加急";
    }

    // 2019-05-23 迭代 订单排位
    let ranking = "";
    if (parseInt(r.order_service.is_ranking) === 1) {
      let rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + "号";
      }
    }

    // 审核标识
    let check = "";
    if (
      parseInt(r.order.check_state) === 11 ||
      parseInt(r.order.check_state) === 51
    ) {
      check = "审核";
    }

    // 留言
    let mesg = "";
    if (r.order.new_bbs_content && r.order.new_bbs_content.id) {
      mesg = "have";
    }

    if (r.order.is_new_bbs) {
      mesg = "new";
    }

    let urgent = ''
    if (r.order.reminder && parseInt(r.order.reminder.count) > 0) {
      urgent = '已催单' + r.order.reminder.count + '次'
    }

    return [
      {
        type: "",
        label: source,
        plain: darkplain,
      },
      {
        type: kindType,
        label: kind,
        plain: plain,
      },
      {
        type: "danger",
        label: abnormal,
        plain: darkplain,
      },
      {
        type: "danger",
        label: charge,
        plain: darkplain,
      },
      {
        type: "danger",
        label: expedited,
        plain: darkplain,
      },
      {
        type: "danger",
        label: ranking,
        plain: darkplain,
      },
      {
        type: "warning",
        label: check,
        plain: darkplain,
      }, {
        type: "warning",
        label: urgent,
        plain: plain,
      }
    ];
  }
  private nowId: number = -1;
  private nowSid: number = -1;
  private bbsDialogVisible: boolean = false;
  // 不根据state判断，所以永远置为1
  private state: number = 1;
  // 留言
  private bbsHandle(r: any) {
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.bbsDialogVisible = true;
  }
  private closeBbs(value: boolean) {
    this.bbsDialogVisible = value;
  }
  private confirmButton = false

  get getOrderDetail(): Function {
    if (this.all) {
      return getAllOrderDetail;
    } else if (this.isCheckOrder) {
      return getOrderCheckDetail
    } else {
      return getOrderDetail;
    }
  }

  private getOrderDetaila() {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      order_service_id: this.orderServiceId,
      order_id: this.orderId,
    };
    this.getOrderDetail(params)
      .then((res: any) => {
        if (res.data) {

          this.orderDetail = res.data;
          //20240809的报修单详情
          if (this.orderDetail.order.order_task) {
            this.orderDetail.order.order_task.forEach((element:any) => {
              if (!this.orderDetail.order.order_remark) {
                this.orderDetail.order.order_remark = []
              }
              this.orderDetail.order.order_remark.push({
                classify_name: '',
                remark: "【维修小结】" + element.fix_summary,
                addtime: element.finish_time,
                user_name: element.user_name })
            });
          }
          
        }
      })
      .catch((err: any) => {
        let msg = err.msg
      });
  }
  private editDialogData: any = {
    visible: false,
    title: '',
    name: '',
    inputValue: '',
    inputHint: '',
    cancel: '',
    confirm: '',
    callBack: '',
    rules: []
  };
  private buttonClick(button:any) {
    switch (parseInt(button.id)) {
      case 1:
        this.editDialogData = {
          visible: true,
          title: '挂单原因',
          name: '备注',
          inputValue: '',
          inputHint: '请填写挂单原因',
          cancel: '取消',
          confirm: '确定',
          callBack: 'handUpCallBack',
          rules: [{ required: true, message: '请填写备注', trigger: 'blur' }]
        };
        // 挂单
        break;
      case 2:
        // this.customerConfirm()
        // 代客
        break;
      case 3:
        this.editDialogData = {
          visible: true,
          title: '关闭订单',
          name: '备注',
          inputValue: '',
          inputHint: '请填写备注',
          cancel: '取消',
          confirm: '确定',
          callBack: 'closeOrderCallBack',
          rules: [{ required: true, message: '请填写备注', trigger: 'blur' }]
        };
        // 关闭
        break;
    }
  }

  private isNull(val: any) {
    if (val) {
      return val;
    } else {
      return '~';
    }
  }

  private referesh() {
    this.getOrderDetaila()
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
